import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteAccountMutationAtom = createMutationAtomFactory(
  'crm.accountDelete',
  (params: { id: string }) => ({
    crmAccountDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
